import React from 'react'
import { useNavigate } from 'react-router-dom'

import { BaseView, BaseText } from '@/components/base'
import { Avatar } from '@/components/Avatar'
import { AppIcons } from '@/components/AppIcons'
import { UserBySearchDTO } from '@/domain/identity'
import { getAvatarProps } from '@/utils/avatarUtils'

interface BlockedUserItemProps {
  user: UserBySearchDTO
}

export const BlockedUserItem: React.FC<BlockedUserItemProps> = ({ user }) => {
  const navigate = useNavigate()

  const avatarProps = getAvatarProps({
    first_name: user.first_name,
    last_name: user.last_name,
    avatar_path: user.avatar_path,
    avatarBg: user.avatarBg,
    id: user.id,
  })

  const displayName = user.first_name || user.username || 'Unknown'
  const subtitle = user.username ? `@${user.username}` : ''

  const handlePress = () => {
    navigate(`/user-profile/${user.id}`)
  }

  return (
    <BaseView
      bgColor="background.cardItemRoot"
      row
      align="center"
      gap={12}
      className="cursor-pointer hover:opacity-90 active:scale-[0.99] transition-all duration-150 ease-out"
      style={{
        padding: '12px',
        borderRadius: '34px',
        minHeight: '72px',
      }}
      onClick={handlePress}
    >
      {/* Avatar */}
      <Avatar
        size={52}
        initials={avatarProps.initials}
        imageUrl={avatarProps.avatarUrl}
        gradientColors={avatarProps.backgroundGradient}
        fullSize={false}
      />

      {/* User Info */}
      <BaseView className="flex-1 min-w-0" gap={6}>
        <BaseText
          fontSize={16}
          fontFamily="semibold"
          color="label.default"
          className="truncate"
        >
          {displayName}
        </BaseText>
        {subtitle && (
          <BaseText
            fontSize={14}
            fontFamily="medium"
            color="label.clickable"
            className="truncate"
          >
            {subtitle}
          </BaseText>
        )}
      </BaseView>

      {/* Right Arrow */}
      <BaseView className="flex-shrink-0">
        <AppIcons name="chevronRight" size={24} color="icon.iconCard" />
      </BaseView>
    </BaseView>
  )
}

export default BlockedUserItem
